import { render, staticRenderFns } from "./record-control.vue?vue&type=template&id=2ced6748&"
import script from "./record-control.vue?vue&type=script&lang=js&"
export * from "./record-control.vue?vue&type=script&lang=js&"
import style0 from "./record-control.vue?vue&type=style&index=0&id=2ced6748&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports